import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section page is-flex is-fullheight is-flex-direction-row is-align-items-center is-justify-content-center" }
const _hoisted_2 = { class: "box login-box" }
const _hoisted_3 = { class: "logo-wrapper mt-4 mb-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "password-rules mb-3" }
const _hoisted_6 = { class: "has-text-weight-bold" }
const _hoisted_7 = {
  key: 2,
  class: "loading center w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" LOGO "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.logo }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _createVNode(_component_n_divider),
      _createCommentVNode(" ERROR HANDLING "),
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            class: "w-100 mb-3",
            title: _ctx.$t('register.failure'),
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('register.credentials_invalid')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" LOGIN FORM "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('register.set_strong_passord')) + ":", 1 /* TEXT */),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('register.at_least_8_characters')), 1 /* TEXT */),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('register.at_least_1_lowercase_characters')), 1 /* TEXT */),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('register.at_least_1_uppercase_characters')), 1 /* TEXT */),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('register.at_least_1_digit')), 1 /* TEXT */),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('register.at_least_1_special_character')) + " [$@$!%*#?&,;]", 1 /* TEXT */)
        ])
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_n_form, {
            key: 1,
            ref: "form",
            class: "w-100",
            model: _ctx.result,
            "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.result) = $event)),
            rules: _ctx.rules,
            path: "username",
            onKeydown: _withKeys(_ctx.onSubmit, ["enter"]),
            "show-label": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('register.form.email_field'),
                path: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.result.email,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.email) = $event)),
                    clearable: "",
                    placeholder: _ctx.$t('register.form.email_field')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('register.form.password_field'),
                path: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.result.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result.password) = $event)),
                    type: "password",
                    "show-password-on": "mousedown",
                    clearable: "",
                    placeholder: _ctx.$t('register.form.password_field')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('register.form.repeat_password_field'),
                path: "passwordRepeat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.result.passwordRepeat,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.result.passwordRepeat) = $event)),
                    type: "password",
                    "show-password-on": "mousedown",
                    clearable: "",
                    placeholder: _ctx.$t('register.form.repeat_password_field')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    class: "w-100",
                    type: "success",
                    disabled: !_ctx.valid,
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('register.register')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules", "onKeydown"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
    ])
  ]))
}